import { render, staticRenderFns } from "./Order_Details.vue?vue&type=template&id=76e69c7f"
import script from "./Order_Details.vue?vue&type=script&lang=js"
export * from "./Order_Details.vue?vue&type=script&lang=js"
import style0 from "./Order_Details.vue?vue&type=style&index=0&id=76e69c7f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports